import React from 'react';
import { StoryblokLink } from '../../../interfaces/StoryblokLink.interface';
import CustomLink from '../../CustomLink/CustomLink';

interface AccordionStateProps {
  expanded?: boolean;
  disabled?: boolean;
}
interface SideNavAccordionHeadingProps {
  label: string;
  state: AccordionStateProps;
  link: StoryblokLink;
}

const SideNavAccordionHeading: React.FC<SideNavAccordionHeadingProps> = ({
  label,
  link,
  state,
}) => {
  return (
    <div
      className={`w-full flex items-center justify-between text-lg font-bold px-6 py-2 transition-all ${
        state.expanded
          ? 'text-text/body-accent'
          : 'text-text/body hover:text-text/body-accent'
      }`}
    >
      <p>{label}</p>
      <span
        className={`h-[24px] w-[24px] bg-no-repeat transition-all ease-in-out ${
          state.expanded
            ? 'rotate-180 bg-text/body-accent'
            : 'bg-text/body group-hover:bg-text/body-accent'
        }`}
        style={{
          WebkitMaskImage: "url('/svgs/chevron.svg')",
          maskImage: "url('/svgs/chevron.svg')",
        }}
      />
    </div>
  );
};

export default SideNavAccordionHeading;
